import { render, staticRenderFns } from "./ObjectsUpdateHttp.vue?vue&type=template&id=5e655713"
import script from "./ObjectsUpdateHttp.vue?vue&type=script&lang=js"
export * from "./ObjectsUpdateHttp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports